
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "证书名称",
      name: "name",
      tableItem: {
        width: 200
      },
      searchItem: {}
    },
    {
      title: "证书级别",
      name: "level",
      searchItem: {type:'select'},
      dict: [
        {code: 0, codeName: '初级'},
        {code: 1, codeName: '中级'},
        {code: 2, codeName: '高级'},
        {code: 3, codeName: '一星'},
        {code: 4, codeName: '二星'},
        {code: 5, codeName: '三星'},
        {code: 6, codeName: '四星'},
        {code: 7, codeName: '五星'},
        {code: 8, codeName: '六星'},
        {code: 9, codeName: '七星'}
      ]
    },
    {
      title: "证书类型",
      name: "classify",
      tableItem: {
        width: 100
      },
      dict: [
        { code: 1, codeName: "个人" },
        { code: 2, codeName: "店端" }
      ]
    },
    {
      title: "证书类别",
      name: "type",
      tableItem: {
        width: 100
      },
      dict: [
        { code: 1, codeName: "培训" },
        { code: 2, codeName: "社会" }
      ]
    },
    {
      title: "证书级别",
      name: "level",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: '初级'},
        {code: 1, codeName: '中级'},
        {code: 2, codeName: '高级'},
        {code: 3, codeName: '一星'},
        {code: 4, codeName: '二星'},
        {code: 5, codeName: '三星'},
        {code: 6, codeName: '四星'},
        {code: 7, codeName: '五星'},
        {code: 8, codeName: '六星'},
        {code: 9, codeName: '七星'}
      ]
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {
        width: 100
      },
      dict: [
        { code: 1, codeName: "有效" },
        { code: 0, codeName: "无效" }
      ]
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'cert/getListByPage',
    ...api
  }
}

const cert = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowKey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api)
  }
}

export default cert
